import { Col } from '@packages/utils';
import styled from 'styled-components';

export const SLinkItemWrapper = styled(Col)`
  background-color: ${({ theme }) => theme.colorPrimaryBgBlue};
  border: 1px solid ${({ theme }) => theme.colorPrimaryBorderLight};
  border-radius: ${({ theme }) => theme.borderRadiusSm}px;
  margin-right: 16px;
`;
